import React from 'react';
import { useIntl } from 'react-intl';
import { Text, CrossIcon } from '../../../../../../../UILibrary';
import { definedTranslation } from '../../../i18n';

type TitleProps = {
  onClose: () => void;
};

export function Title({ onClose }: TitleProps) {
  const intl = useIntl();

  return (
    <div className="flex justify-between items-center ">
      <Text variant="H2" md="Title3">
        {intl?.formatMessage(
          definedTranslation.previewFiles.downloadFilesLabel,
        )}
      </Text>
      <div
        className="flex items-center justify-center w-8 h-8 cursor-pointer"
        onClick={onClose}
      >
        <CrossIcon className="w-6 h-6 sm:w-8 sm:h-8" />
      </div>
    </div>
  );
}
